import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';
import CreateStripeAccount from './CreateStripeAccount';
import CheckStripeAccount from './CheckStripeAccount';
import StripeOnboarding from './StripeOnboarding';
import CheckOnboardingComplete from './CheckOnboardingComplete';
import Logout from './auth/Logout';
import { useSetOnboardingStage, useHasStripeAccount, useContinueFiatOnboarding, useSetContinueFiatOnboarding, useStripeOnboardingStatus } from '../state';
import { updateOnboardingStage } from '../services';
import { ONBOARDING_ROUTES, GENERAL_ROUTES } from '../constants/routes';

const FiatOnboarding = ({ autoContinue = false }) => {
    const navigate = useNavigate();
    const hasStripeAccount = useHasStripeAccount();
    const continueFiatOnboarding = useContinueFiatOnboarding();
    const setContinueFiatOnboarding = useSetContinueFiatOnboarding();
    const stripeOnboardingStatus = useStripeOnboardingStatus();
    const setOnboardingStage = useSetOnboardingStage();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (autoContinue && !continueFiatOnboarding) {
            handleContinue();
        }
    }, [autoContinue, continueFiatOnboarding]);

    useEffect(() => {
        if (stripeOnboardingStatus === 'complete') {
            const updateStage = async () => {
                try {
                    await updateOnboardingStage('complete');
                    setOnboardingStage('complete');
                    navigate(GENERAL_ROUTES.HOME);
                } catch (error) {
                    console.error('Error updating onboarding stage:', error);
                    navigate(GENERAL_ROUTES.ERROR);
                }
            };
            updateStage();
        }
    }, [stripeOnboardingStatus, setOnboardingStage, navigate]);

    const handleContinue = async () => {
        setContinueFiatOnboarding(true);
    }

    const handleBack = async () => {
        setIsLoading(true);
        try {
            // WHILE CRYPTO INACTIVE, SKIP 'SELECT MONEY TYPE'
            // await updateOnboardingStage('select-money-type');
            // setOnboardingStage('select-money-type');
            // navigate(ONBOARDING_ROUTES.SELECT_MONEY_TYPE);

            await updateOnboardingStage('enter-link-id');
            setOnboardingStage('enter-link-id');
            navigate(ONBOARDING_ROUTES.ENTER_LINK_ID);
        } catch (error) {
            console.error('Error going back:', error);
            navigate(GENERAL_ROUTES.ERROR);
        }
        setIsLoading(false);
    };

    if (continueFiatOnboarding) {
        console.log('continueFiatOnboarding:', continueFiatOnboarding);
        if (hasStripeAccount === null) {
            return <CheckStripeAccount />;
        }

        if (hasStripeAccount === false) {
            console.log('navigating to create stripe account');
            return <CreateStripeAccount />;
        }
        console.log('Stripe account created');

        console.log('returning StripeOnboarding');
        return <StripeOnboarding />
    }

    return (
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh)]">
                {continueFiatOnboarding ? (
                    <Loading />
                ) : (
                    <div className="flex flex-col items-center p-8">
                        <div className="w-full max-w-md">
                            <div>
                                <p className="text-l text-center text-white mb-5">
                                    {stripeOnboardingStatus === 'started'
                                        ? "It looks like you didn't complete onboarding with our partner, Stripe. Please continue by clicking here."
                                        : "Tipl partners with Stripe to process payments. When you click continue, you will be taken to Stripe to register your bank details for collecting payments."}
                                </p>
                            </div>
                            <div className="flex justify-center gap-4 mt-2">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="bg-white text-tipl-teal font-semibold w-24 px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300"
                                    disabled={isLoading}
                                >
                                    Back
                                </button>
                                <button
                                    className="bg-orange-200 hover:bg-orange-300 text-black w-24 font-semibold px-4 py-2 rounded-md transition duration-300"
                                    onClick={handleContinue}
                                    disabled={isLoading}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
    )
};

export default FiatOnboarding;
